<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">발신 번호 설정</span>
            <span class="txt">발신 번호를 등록하고 수정할 수 있습니다.(최대 5개 등록 가능)</span>
        </div>

        <div class="com-table-content com-msg-content">
            <div class="table-header com-btn-area">
                <div class="left-box">
                    <button class="com-btn excel" @click="getExcel">엑셀 다운로드</button>
                </div>
                <div class="right-box">
                    <span class="txt">
                        총
                        <span class="blue">{{ totalItemsCount }}</span>
                        건
                    </span>
                    <button class="com-btn blue" @click="sendAddPop">발신번호 등록</button>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 120px" />
                    <col style="width: 320px" />
                    <col style="width: 120px" />
                    <col />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>등록일시</button>
                        </th>
                        <th>발신자명</th>
                        <th>발신번호</th>
                        <th>인증여부</th>
                        <th>비고</th>
                        <th>관리</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in messageChargeCall" :key="index">
                        <td>{{ item.approved_date | formatDate }}</td>
                        <td>{{ item.send_nm }}</td>
                        <td>
                            {{ item.send_no | formatPhoneNumber }}
                            <button
                                :class="item.is_present ? 'com-btn btn-rep small ml-8' : 'com-btn white small ml-8'"
                                @click="setRepresentativeNumber(item)"
                                v-if="item.is_validated === 'APPROVED'"
                            >
                                {{ item.is_present ? '대표' : '대표번호 설정' }}
                            </button>
                        </td>

                        <td>
                            <template v-if="item.is_validated === 'NEW'">
                                <span class="auth-status auth-apply">
                                    <button class="com-btn dark-gray" @click="openAuthRequestModal(item)">
                                        인증 신청
                                    </button>
                                </span>
                            </template>
                            <template v-else-if="item.is_validated === 'PROGRESS'">
                                <span class="auth-status auth-ing">심사중</span>
                            </template>
                            <template v-else-if="item.is_validated === 'APPROVED'">
                                <span class="auth-status auth-complete">인증완료</span>
                            </template>
                            <template v-else-if="item.is_validated === 'REJECTED'">
                                <span class="auth-status auth-ing" style="color: red">반려</span>
                            </template>
                        </td>
                        <td></td>
                        <td>
                            <button type="button" class="com-btn red" @click="deletePhoneNumber(item)">삭제</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>

        <!-- 발신번호 등록 레이어 팝업 -->
        <div v-show="sendPop" class="layer-pop square">
            <div class="view-content w600">
                <button class="close" @click="sendPop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <p class="pop-tit">발신번호 등록</p>
                    <div class="send-num-pop">
                        <div class="info-wrap">
                            발신번호 등록 시 최초 1회 인증 후 사용이 가능합니다. 등록 후 ‘인증 요청'버튼을 눌러 인증을
                            진행해주세요.
                        </div>

                        <table class="com-table">
                            <tbody>
                                <tr>
                                    <th>발신자명</th>
                                    <td>
                                        <input
                                            maxlength=""
                                            type="text"
                                            placeholder="발신자명을 입력하세요."
                                            v-model="name"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>발신번호</th>
                                    <td>
                                        <input
                                            maxlength=""
                                            type="text"
                                            placeholder="발신번호를 입력하세요."
                                            v-model="tel"
                                            v-on:input="validateNumber"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="sendPop = false">취소</button>
                            <button class="com-btn blue" @click="onClickRegistMessageCharge">등록</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 발신번호 인증요청 레이어 팝업 -->
        <div v-show="sentNumAuthRequestPop && selectedItem" class="layer-pop square">
            <div class="view-content w700">
                <button class="close" @click="closeAndReset">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <p class="pop-tit">발신번호 인증 요청</p>
                    <div class="send-num-pop">
                        <table class="com-table">
                            <tbody>
                                <tr>
                                    <th>
                                        센터명
                                        <span class="require">*</span>
                                    </th>
                                    <td>
                                        <input maxlength="30" type="text" :value="centerInfo.centerName" readonly />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <div class="tit">
                                            <span>통신증명원</span>
                                            <span class="require">*</span>
                                            <div class="com-tooltip">
                                                <button class="icon"></button>
                                                <div class="detail">
                                                    <p class="txt">
                                                        1. 통신가입 사실확인서(** 마스킹번호 없이 번호 모두 노출 필수)
                                                        <br />
                                                        - SK : 이용계약등록사항증명서
                                                        <br />
                                                        - KT : 원부 증명서
                                                        <br />
                                                        - LG : 가입사실 확인서
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </th>
                                    <td>
                                        <span class="attach-file-name">{{ displayedFileName1 }}</span>
                                        <button
                                            type="button"
                                            class="com-btn block right"
                                            @click="onFileSelect('certification')"
                                        >
                                            찾아보기
                                        </button>
                                        <input
                                            type="file"
                                            @change="handleFileUpload('certification', $event)"
                                            style="display: none"
                                            ref="fileInputCertification"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        사업자등록증
                                        <span class="require">*</span>
                                    </th>
                                    <td>
                                        <span class="attach-file-name">{{ displayedFileName2 }}</span>
                                        <button
                                            type="button"
                                            class="com-btn block right"
                                            @click="onFileSelect('businessCertification')"
                                        >
                                            찾아보기
                                        </button>
                                        <input
                                            type="file"
                                            @change="handleFileUpload('businessCertification', $event)"
                                            style="display: none"
                                            ref="fileInputBusinessCertification"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="info-wrap other">
                            <p class="tit">
                                위임장 동의
                                <span class="require">*</span>
                            </p>
                            <p class="txt">
                                상기 위임자는 “등록할 회신(발신)번호”의 적법한 권리자로서, 상기 이용자 ㈜핏투데이케어가
                                ㈜에스엠티엔티가 제공하는 문자서비스 이용 시, 메시지(SMS/LMS/MMS 등) 발송을 위한
                                회신(발신)번호로, “등록할 회신(발신)번호”를 위임자의 동의일로부터 이용자의 “등록할
                                회신(발신)번호” 삭제일까지 이용하는 것에 동의합니다. 전기통신사업법 제 84조 2 및
                                ‘거짓으로 표시된 전화번호로 인한 이용자 피해 예방 등에 관한 고시’에 의거하여 등록하신
                                발신번호로 인해 생기는 피해는 이용자가 책임을 지며, 그 외 명시되지 않은 사항은 가입하신
                                서비스의 이용약관에 적용하는 것에 동의합니다.
                            </p>
                            <div class="com-check">
                                <input id="agreeCheckbox" name="agree" type="checkbox" v-model="isAgreed" />
                                <label for="agreeCheckbox">내용을 이해하였고 동의합니다.</label>
                            </div>
                        </div>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="closeAndReset">취소</button>
                            <!-- <button class="com-btn blue" @click="uploadFiles"> -->
                            <button class="com-btn blue" @click="submitImages">신청</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { pagingInfo } from '@/assets/js/common';
import paymentApi from '@/assets/js/paymentApi';
import XLSX from 'xlsx';

export default {
    name: 'messageHistory',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        displayedFileName1() {
            return this.attachedFileName1.length > 10
                ? `${this.attachedFileName1.substr(0, 20)}...`
                : this.attachedFileName1;
        },
        displayedFileName2() {
            return this.attachedFileName2.length > 10
                ? `${this.attachedFileName2.substr(0, 20)}...`
                : this.attachedFileName2;
        },
    },
    watch: {},
    data() {
        return {
            imagePop: false,
            sendPop: false,
            sentNumAuthRequestPop: false,
            currentSender: null,
            centerId: '',
            sortTypeList: ['10줄보기', '20줄보기', '50줄보기', '100줄보기'],
            sortTypeValueList: [10, 20, 50, 100],
            pagingInfo: { ...pagingInfo },
            searchStr: '',
            period: '',
            historyList: [],
            searchSmsType: '',
            sendOk: '',
            sender: '',
            staffNameList: [],
            staffValList: [],
            messageChargeCall: [],
            name: '',
            tel: '',
            selectedItem: {},
            attachedFileName1: '첨부파일명.jpg',
            attachedFileName2: '첨부파일명.jpg',
            imagesList: [],
            images: [],
            imageFile: {
                fileName: '',
                mimetype: 'blob',
                base64Data: '',
            },
            businessCertification: {
                fileName: '',
                mimetype: 'blob',
                base64Data: '',
            },
            certification: {
                fileName: '',
                mimetype: 'blob',
                base64Data: '',
            },
            totalItemsCount: 0,
            isAgreed: false,
            centerInfo: {},
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터id
        this.init();
    },
    filters: {
        formatDate(value) {
            if (value) {
                const date = new Date(value);
                const year = date.getFullYear();
                const month = `0${date.getMonth() + 1}`.slice(-2);
                const day = `0${date.getDate()}`.slice(-2);
                return `${year}-${month}-${day}`;
            }
            return '';
        },
        formatPhoneNumber(value) {
            if (value) {
                const phone = value.replace(/[^0-9]/g, ''); // 숫자가 아닌 문자 제거
                if (phone.length === 11) {
                    return phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                } else if (phone.length === 10) {
                    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                } else if (phone.length === 9) {
                    return phone.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                }
            }
            return value;
        },
    },
    methods: {
        init() {
            this.onSearchList();
            this.getCenterInfo();
            // this.senderList();
        },

        async getCenterInfo() {
            try {
                const response = await api.get(`/admin/api/center/${this.centerId}`);
                this.centerInfo = response.data;
                console.log('centerInfocenterInfocenterInfocenterInfocenterInfocenterInfo', this.centerInfo);
            } catch (error) {
                console.error('API 요청 실패:', error);
            }
        },
        async setRepresentativeNumber(item) {
            try {
                const response = await paymentApi.put(`admin/api/center-phone/${this.centerId}/set-present`, {
                    sendNumber: item.send_no,
                });

                if (response.status === 200) {
                    item.isRepresentative = true;
                    alert('대표번호로 설정되었습니다.');
                    this.onSearchList();
                }
            } catch (error) {
                console.error('Error setting representative number', error);
            }
        },
        async onSearchList() {
            try {
                this.isLoading = true;
                const data = await this.getMessageChargeCall();
                // this.setPageParams(data);

                this.messageChargeCall = data;

                this.isLoading = false;
                console.log('===> Success Loading centerList : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        async submitAuthRequest() {
            if (!this.validateAuthRequestInputs()) {
                alert('모든 필수 항목을 입력해주시고, 동의 체크박스를 선택해주세요.');
                return;
            }

            try {
                // 인증 요청 API 호출
                const response = await api.post('api/', {
                    centerName: this.centerName, // 센터명
                    // 통신증명원, 사업자등록증 파일 등
                });

                // 성공 알림
                alert('인증 요청이 성공적으로 완료되었습니다.');
                this.sentNumAuthRequestPop = false; // 모달 닫기
                // 추가적인 성공 후 처리 로직
            } catch (error) {
                console.error('인증 요청 실패:', error);
                alert('인증 요청 중 오류가 발생했습니다. 다시 시도해주세요.');
            }
        },
        validateAuthRequestInputs() {
            return this.centerName && this.isChecked;
        },
        async getMessageChargeCall() {
            const d = new Date();
            const ts = d.getTime();
            // 스웨거 검색: 발신번호 목록
            try {
                const response = await paymentApi.post(`admin/api/center-phone/${this.centerId}/list`, {
                    page: this.pagingInfo.page,
                    skip: this.pagingInfo.limit,
                });
                this.totalItemsCount = response.data.list.length;

                console.log('발신번호 목록:', response.data.list);
                return response.data.list; // 응답의 데이터 부분을 반환합니다.
            } catch (error) {
                console.error(error);
                throw error; // 오류가 발생하면 이를 다시 던집니다.
            }
        },

        async onClickRegistMessageCharge() {
            if (!this.name || !this.tel) {
                alert('발신자명과 발신번호를 모두 입력해주세요.');
                return;
            }

            try {
                const response = await api.post(`admin/api/center/${this.centerId}/message/phone`, {
                    senderName: this.name,
                    senderNo: this.tel,
                });
                console.log('등록 성공:', response.data);

                // 등록된 데이터를 테이블에 추가하기 위한 처리
                const now = new Date();
                now.setHours(now.getHours() + 9);
                const registeredTime = now.toISOString().replace('T', ' ').substring(0, 19); // 'YYYY-MM-DD HH:MM:SS' 형식
                this.messageChargeCall.push({
                    senderName: this.name,
                    senderNo: this.tel,
                    registeredTime,
                    authStatus: '인증 신청',
                });

                // 모달 닫고 입력 필드 초기화
                this.sendPop = false;
                this.name = '';
                this.tel = '';
                this.onSearchList();
            } catch (error) {
                console.error('등록 실패:', error);
                alert('등록 중 오류가 발생했습니다.');
            }
        },
        openAuthRequestModal(item) {
            this.selectedItem = item; // 현재 선택된 발신자 정보 저장
            this.sentNumAuthRequestPop = true; // 인증 요청 팝업 표시
        },
        getMessageChargeCallPost() {
            // 스웨거 검색: 발신번호 등록
            return api.post(`admin/api/center/${this.centerId}/message/phone`, {
                senderName: `${this.name}`,
                senderNo: `${this.tel}`,
            });
        },
        async onClickDeleteMessageCharge(senderNo) {
            try {
                this.senderNo = senderNo;
                console.log(this.senderNo);
                const { data } = this.getMessageChargeCallDelete();
                console.log('삭제처리 되었습니다.', data);
                alert('삭제 되었습니다.');
                this.onSearchList();
            } catch (e) {
                //
                console.log(e);
                console.log('삭제 처리 되지 않았습니다.');
            }
        },

        getMessageChargeCallDelete() {
            // 스웨거 검색: 발신번호 삭제
            return api.delete(`admin/api/center/${this.centerId}/message/phone/${this.senderNo}`, {});
        },
        closeAndReset() {
            this.sentNumAuthRequestPop = false; // 팝업 닫기
            // 파일 이름과 파일 데이터 초기화
            this.attachedFileName1 = '첨부파일명.jpg';
            this.attachedFileName2 = '첨부파일명.jpg';
            this.certification = { fileName: '', mimetype: 'blob', base64Data: '' };
            this.businessCertification = { fileName: '', mimetype: 'blob', base64Data: '' };
            this.isAgreed = false; // 체크박스 상태도 초기화
            this.resetFileInput('certification');
            this.resetFileInput('businessCertification');
        },
        resetFileInput(type) {
            if (type === 'certification') {
                this.$refs.fileInputCertification.value = '';
            } else if (type === 'businessCertification') {
                this.$refs.fileInputBusinessCertification.value = '';
            }
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },
        getExcel() {
            const dataWS = XLSX.utils.json_to_sheet(this.messageChargeCall);
            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, 'messageChargeCall');
            XLSX.writeFile(wb, 'messageChargeCall.xlsx');
        },
        onFileSelect(type) {
            if (type === 'certification') {
                this.$refs.fileInputCertification.click();
            } else if (type === 'businessCertification') {
                this.$refs.fileInputBusinessCertification.click();
            }
        },
        handleFileUpload(type, event) {
            const file = event.target.files[0];
            if (file) {
                if (!file.type.match('image/*')) {
                    alert('이미지 파일만 업로드 가능합니다.');
                    this.resetFileInput(type);
                    return;
                }

                if (file.size > 5 * 1024 * 1024) {
                    alert('파일 크기는 5MB 미만이어야 합니다.');
                    this.resetFileInput(type);
                    return;
                }

                const img = new Image();
                img.src = URL.createObjectURL(file);
                img.onload = () => {
                    if (img.width > 3000 || img.height > 3000) {
                        alert('이미지 해상도는 3000x3000 이하이어야 합니다.');
                        this.resetFileInput(type);
                        return;
                    }

                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const base64Data = e.target.result.split(',')[1];
                        this[type] = {
                            base64data: base64Data,
                            fileName: file.name,
                            mimetype: file.type,
                        };
                        if (type === 'certification') {
                            this.attachedFileName1 = file.name;
                        } else if (type === 'businessCertification') {
                            this.attachedFileName2 = file.name;
                        }
                    };
                    reader.readAsDataURL(file);
                };
            }
        },

        validateNumber(event) {
            this.tel = this.tel.replace(/[^0-9]/g, '');
        },
        sendAddPop() {
            if (this.totalItemsCount >= 5) {
                alert('발신번호는 5개까지 등록 가능합니다');
            } else {
                this.sendPop = true;
            }
            this.sendPop = true;
        },
        reset() {
            this.smsReservePop = false;
            this.isAgreed = false;
            this.selectedItem.send_no = '';
            this.certification = '';
            this.businessCertification = '';
            this.sentNumAuthRequestPop = false;
            this.onSearchList();
        },
        async deletePhoneNumber(item) {
            try {
                const response = await paymentApi.delete(
                    `admin/api/center-phone/${this.centerId}/delete/${item.send_no}`
                );
                console.log(response);
                alert('삭제되었습니다.');
                this.onSearchList();
            } catch (error) {
                console.error(error);
                alert(error.response.data.message || '발신번호 삭제 중에 에러가 발생하였습니다.');
            }
        },
        async submitImages() {
            if (!this.isAgreed) {
                alert('내용을 확인하고 동의해주세요.');
                return;
            }
            if (
                !this.certification ||
                !this.businessCertification ||
                this.certification.fileName === '' ||
                this.businessCertification.fileName === ''
            ) {
                alert('첨부 파일을 확인해 주세요.');
                return;
            }
            try {
                const response = await paymentApi.post(`/admin/api/center-phone/${this.centerId}/request-approval`, {
                    sendNumber: this.selectedItem.send_no,
                    certification: this.certification,
                    businessCertification: this.businessCertification,
                });

                // 요청이 성공적으로 처리되면, 성공 메시지를 표시합니다.
                console.log('업로드 성공:', response.data);
                alert('발신번호 등록 신청이 완료되었습니다.');
                this.reset();
            } catch (error) {
                console.error('업로드 실패:', error);

                let errorMessage = '발신번호 등록 중 오류가 발생했습니다. 다시 시도해주세요.';
                if (error.response && error.response.data && error.response.data.message) {
                    if (error.response.data.message === '첫번째 이미지 업로드 중 에러가 발생하였습니다.') {
                        errorMessage = '첨부 파일을 확인해 주세요.';
                    } else {
                        errorMessage = error.response.data.message;
                    }
                }

                alert(errorMessage);
            }
        },
    },
    fetchSenderList() {
        return api.get(`/admin/api/customer-app/main/center/${this.centerId}/teachers/list`);
    },

    viewImagePop(img) {
        this.imagePop = true;
        this.img = img;
    },
    // 페이징 이벤트
    handlerPagenation(event) {
        this.pagingInfo.page = event;
        this.onSearchList();
    },
};
</script>
<style lang="scss">
.send-num-pop th span {
    font-size: 14px;
}
</style>
